var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "21px",
    viewBox: "0 0 32 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "87C02D68-599D-4C5F-81F1-2A66A04BCD99") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-551.000000, -186.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "ship1",
    transform: "translate(552.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 22.5,
    cy: 16.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 6.5,
    cy: 16.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5491943,16.2683105 L29.289917,16.2683105 L29.289917,12.4988029 C29.289917,11.7088194 28.8249081,10.992856 28.1031864,10.6716213 L26.2659308,9.85386799 C25.7212073,9.6114143 25.3702393,9.07103697 25.3702393,8.47479248 L25.3702393,8.47479248 C25.3702393,7.84652193 25.1231973,7.24344486 24.6824338,6.79572685 L24.3484819,6.45650581 C23.784583,5.88370945 23.0144122,5.56115723 22.2106226,5.56115723 L19.9736328,5.56115723 L19.9736328,16.0430908",
    id: "Path-48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,16.27 L9,16.27",
    id: "Path-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.71721371,16.27 L0.250488281,16.27 L0.250488281,2.97033691 C0.250488281,1.86576741 1.14591878,0.970336914 2.25048828,0.970336914 L14.0458984,0.970336914 C15.1504679,0.970336914 16.0458984,1.86576741 16.0458984,2.97033691 L16.0458984,16.27",
    id: "Path-49"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCar);
export default __webpack_public_path__ + "static/media/ico_car.e38bec6fd51a6d20ccbcfd3e591058c3.svg";
export { ForwardRef as ReactComponent };